import { useFieldArray } from 'react-hook-form';

export const useAddressInput = () => {
  const {
    fields: addresses,
    append: appendAddress,
    remove: removeAddress,
  } = useFieldArray({
    name: 'residentialAddresses',
  });

  return {
    addresses,
    additionalAddresses: addresses.length === 0 ? [] : addresses.slice(1),
    appendAddress,
    removeAddress,
  };
};
